import { getDeliveryChallanDocumentLabel } from './deliveryChallanDocumentTypes';

export const TODAY_DC_DETAIL_COLUMNS = [
  { key: 'delivery_challan_no', label: 'DC No' },
  { key: 'delivery_challan_date', label: 'Date' },
  { key: 'delivery_challan_time', label: 'Time', align: 'center' },
  { key: 'customer_name', label: 'Customer' },
  { key: 'consignee_projectname', label: 'Site' },
  { key: 'grade', label: 'Grade' },
  { key: 'unit', label: 'Unit', align: 'center' },
  { key: 'dc_qty', label: 'Qty', align: 'end' },
  { key: 'rate', label: 'Rate', align: 'end' },
  { key: 'amount', label: 'Amount', align: 'end' },
  { key: 'customer_vehicle_no', label: 'Vehicle No' },
  { key: 'driver_name', label: 'Driver' },
];

export const TODAY_DC_SUMMARY_COLUMNS = [
  { key: 'customer_name', label: 'Customer' },
  { key: 'consignee_projectname', label: 'Site' },
  { key: 'grade', label: 'Grade' },
  { key: 'delivery_mode', label: 'Mode of Delivery' },
  { key: 'dc_qty_total', label: 'Qty', align: 'end' },
  { key: 'rate', label: 'Rate', align: 'end' },
  { key: 'amount', label: 'Amount', align: 'end' },
  { key: 'sales_rep_name', label: 'Marketing' },
];

export function mapDeliveryChallanListRow(dc) {
  const salesOrder = dc.work_schedule?.sales_order_detail?.sales_order;
  const prefix = salesOrder?.prefix ?? '';
  const orderNo = salesOrder?.order_no ?? '';
  return {
    plant: dc.work_schedule?.plant?.alias_name ?? '',
    delivery_challan_no: dc.delivery_challan_no,
    document_type: getDeliveryChallanDocumentLabel(dc.document_type),
    delivery_challan_date: dc.delivery_challan_date,
    delivery_challan_time: dc.delivery_challan_time,
    batch_no: dc.batch_no,
    order_no: `${prefix}${orderNo}`,
    workschedule_no: dc.work_schedule?.schedule_no ?? '',
    customer_name: salesOrder?.consignee?.customer?.name ?? '',
    sales_rep_name: salesOrder?.consignee?.customer?.salesrep?.name ?? '',
    consignee_projectname: salesOrder?.consignee?.project_name ?? '',
    production_plant: dc.production_plant?.name ?? '',
    production_qty: dc.production_qty,
    purchase_qty: dc.purchase_qty,
    other_qty: dc.other_qty,
    received_qty: dc.received_qty,
    client_adjust_qty: dc.client_adjust_qty,
    dc_qty: dc.dc_qty,
    accepted_qty: dc.accepted_qty ?? 0,
    rate: dc.rate ?? 0,
    amount: dc.amount ?? 0,
    unit: dc.unit ?? 'CUM',
    driver_name: dc.driver_name ?? '',
    invoice_qty: dc.invoice?.invoice_qty,
    customer_vehicle_no: dc.vehicle?.name ? dc.vehicle.name : dc.customer_vehicle_no,
    delivery_mode: dc.work_schedule?.delivery_mode ?? '',
    grade: dc.work_schedule?.sales_order_detail?.product?.name ?? '',
    dc_invioce: dc.status === false ? 'Cancelled' : dc.invoice?.invioce_no ? dc.invoice.invioce_no : 'Pending',
    status: dc.status ? 'Active' : 'Cancelled',
    id: dc.id,
    is_batch_report_needed: salesOrder?.company?.is_batch_report_needed ? 'Yes' : 'No',
    hide_row_edit: dc.work_schedule?.is_schedule_completed ? 'Yes' : 'No',
    hide_row_print: dc.checkout_no ? 'No' : 'Yes',
  };
}

export function formatTodayDcCellValue(value, key) {
  if (value === null || value === undefined || value === '') {
    return key === 'amount' || key === 'rate' || key === 'dc_qty' || key === 'dc_qty_total' ? '-' : '';
  }
  if (key === 'dc_qty_total' || key === 'dc_qty' || key === 'amount' || key === 'rate') {
    const numericValue = Number(value);
    return Number.isFinite(numericValue) ? numericValue.toFixed(2) : value;
  }
  return value;
}

export function buildTodayDcSummaryRows(rows) {
  const groups = new Map();

  rows.forEach((row) => {
    const deliveryMode = (row.delivery_mode || '').toUpperCase();
    const groupKey = [
      row.customer_name || '',
      row.consignee_projectname || '',
      row.grade || '',
      deliveryMode,
    ].join('|');

    if (!groups.has(groupKey)) {
      groups.set(groupKey, {
        customer_name: row.customer_name || '',
        consignee_projectname: row.consignee_projectname || '',
        grade: row.grade || '',
        delivery_mode: deliveryMode,
        dc_qty_total: 0,
        amount: 0,
        rate: Number(row.rate) || 0,
        sales_rep_name: row.sales_rep_name || '',
        _rate_sum: 0,
        _rate_count: 0,
      });
    }

    const group = groups.get(groupKey);
    group.dc_qty_total += Number(row.dc_qty) || 0;
    group.amount += Number(row.amount) || 0;
    group._rate_sum += Number(row.rate) || 0;
    group._rate_count += 1;
    if (!group.sales_rep_name && row.sales_rep_name) {
      group.sales_rep_name = row.sales_rep_name;
    }
  });

  return Array.from(groups.values()).map((group) => ({
    customer_name: group.customer_name,
    consignee_projectname: group.consignee_projectname,
    grade: group.grade,
    delivery_mode: group.delivery_mode,
    dc_qty_total: Number(group.dc_qty_total.toFixed(2)),
    amount: Number(group.amount.toFixed(2)),
    rate: group._rate_count
      ? Number((group._rate_sum / group._rate_count).toFixed(2))
      : 0,
    sales_rep_name: group.sales_rep_name,
  }));
}

export function buildTodayDcSummaryCards(rows) {
  const formatValue = (value) => Number(value || 0).toFixed(2);
  const dcQty = rows.reduce((sum, row) => sum + (Number(row.dc_qty) || 0), 0);
  const amount = rows.reduce((sum, row) => sum + (Number(row.amount) || 0), 0);

  return [
    {
      label: 'No. of DC',
      value: String(rows.length),
      gradient: 'linear-gradient(135deg, #186098 0%, #0090D8 55%, #5EC8F0 100%)',
      shadow: '0 8px 20px rgba(0, 144, 216, 0.28)',
    },
    {
      label: 'DC Qty',
      value: formatValue(dcQty),
      gradient: 'linear-gradient(135deg, #305870 0%, #186098 55%, #5AA8D8 100%)',
      shadow: '0 8px 20px rgba(48, 88, 112, 0.24)',
    },
    {
      label: 'Amount',
      value: formatValue(amount),
      gradient: 'linear-gradient(135deg, #0E6A98 0%, #0090D8 55%, #40B8E8 100%)',
      shadow: '0 8px 20px rgba(0, 144, 216, 0.24)',
    },
  ];
}
